export const Publication = 'NonLinear/PublicationLog';
export const GetPlatforms = 'NonLinear/Platforms';
export const PublicationRights = 'NonLinear/PublicationRights';
export const PublicationRightGlobal = 'NonLinear/PublicationRightGlobal';
export const PublicationRightPerpetuity = 'NonLinear/PublicationRightPerpetuity';
export const PublicationRightTerritory = 'NonLinear/PublicationRightTerritory';
export const PublicationRightExpiry = 'NonLinear/PublicationRightExpiry';
export const PublicationRightRestrictions = 'NonLinear/PublicationRightRestrictions';
export const Mode = 'NonLinear/CanEdit';
export const DeletedCues = 'Cuesheets/DeletedCues';
export const AmendmentHistory = 'Cuesheets/AmendmentHistory';
export const CueHistory = 'Cues/CueHistory';
export const ProgrammeCategory = 'NonLinear/ProgrammeCategory';
export const ProgrammeCategoryProductionType = 'NonLinear/ProgrammeCategoryProductionType';
export const ProgrammeCategoryFormat = 'NonLinear/ProgrammeCategoryFormat';
export const NLValidation = 'NonLinear/Validation';
export const CanEditNonLinearForm = 'NonLinear/CanEditForm';

// #region Auth Routes
export const Login = 'Login';
export const PurgeCookies = 'Purge';
export const GetEmailVerificationStatus = 'EmailVerificationStatus';
export const SendEmailVerificationLink = 'EmailVerificationLink';
export const ResendEmailVerificationLink = 'EmailVerificationLink/Resend';
export const VerifyEmailByLink = 'EmailVerification';
export const Get2FADetails = 'TwoFaOptions';
export const SendCodeToEmail = 'EmailVerificationCode';
export const SendCodeToMobile = 'TextVerificationCode';
export const Verify2FA = 'Gateway';
export const GetGateway = 'Gateway';
// #endregion


/*
 * User profile
 */

export const GetUserProfile = 'User/UserProfile';
export const SetUserMobileNumber = 'User/UserProfile/Mobile';
export const VerifyUserMobileNumber = 'User/UserProfile/Verify';
export const ResendUserMobileVerificationCode = 'User/UserProfile/Mobile/Resend';


// WEBPACK FOOTER //
// ./src/apiRoutes.js